//removeIf(production)
import ClaroluzEventDispatch from "./claroluz-event-dispatch";
import ClaroluzEventError from "./claroluz-event-error";
//endRemoveIf(production)

class ClaroluzQr {
    private qrScannerSelector: string;
    private qrScanner: any;
    private scannerElement: any;

    constructor(QrScanner: any, qrScannerSelector: string) {
        
        this.qrScannerSelector = qrScannerSelector;
        this.validateQrScannerSelector();

        this.qrScanner = QrScanner;
        this.setScanner();
    }

    private setScanner() {
        let options = {
            highlightScanRegion: true,
            onDecodeError: (error: any) => {
                let debug = appProperties().debug;

                if (debug) {
                    console.error(error);
                }
            }
        };

        this.scannerElement = new this.qrScanner(
            document.querySelector(this.qrScannerSelector), 
            (result: any) => this.processResult(result),
            options
        );
    }

    private validateQrScannerSelector(): boolean {
        if (!this.qrScannerSelector) {
            throw new Error('Qr scanner selector not found');
        }

        if (typeof this.qrScannerSelector !== 'string') {
            throw new Error('Qr scanner selector is not a string');
        }

        if (this.qrScannerSelector.charAt(0) !== '.' && this.qrScannerSelector.charAt(0) !== '#') {
            throw new Error('Qr scanner selector must start with "." or "#"');
        }

        return true;
    }

    private processResult(result: any) {
        let data = result.data;

        if (data) {
            this.dispatchBillEvent(data);
            this.stop();
        } else {
            this.dispatchErrorEvent();
        }
        
    }

    private dispatchBillEvent(data: object) {
        new ClaroluzEventDispatch('claroluz_bill', data);
    }

    private dispatchErrorEvent(message?: string) {
        let error = message ?? 'ERROR_QR_CODE';
        new ClaroluzEventError('qr-code', error);
    }

    public async hasCamera() {
        return await this.qrScanner.hasCamera();
    }

    public async start() {
        try {
            let cameras = await this.qrScanner.listCameras();

            if (cameras.length > 0) {
                cameras.forEach(async (camera: any) => {
                    if (camera.label.length) {
                        if (camera.label.includes('back') && camera.label.includes('0')) {
                            await this.scannerElement.setCamera(camera.id);
                        }
                    }                    
                });
            }

            await this.scannerElement.start();
        } catch (error) {
            if (error === 'Camera not found.') {
                this.dispatchErrorEvent('ERROR_CAMERA_NOT_FOUND');
            } else {
                this.dispatchErrorEvent();
            }            
        }
    }

    public stop() {
        this.reset();
    }

    public destroy() {
        let debug = appProperties().debug;

        try {
            this.scannerElement.destroy();
        } catch (error) {
            if (debug) {
                console.error(error);
            }
        }
        
        this.scannerElement = null;
    }

    public reset() {
        this.scannerElement.stop();
        this.destroy();

        this.setScanner();
    }

    public testResult(result: any) {
        this.processResult(result);
    }
}

//removeIf(production)
export default ClaroluzQr;

function appProperties() {
    return {
        debug: true
    }
}
//endRemoveIf(production)